import { createReducer, on } from '@ngrx/store';
import * as InventoryActions from '../actions/inventory.actions';
import { Asset } from '@app/models/asset';

export interface InventoryState {
  assets: Asset[];
  error: any;
  loading: boolean;
  sellOfferError: any;
  selling: boolean;
  deleteOfferError: any;
  deleting: boolean;
}

export const initialState: InventoryState = {
  assets: [],
  error: null,
  selling: false,
  sellOfferError: false,
  loading: true,
  deleting: false,
  deleteOfferError: null,
};

export const inventoryReducer = createReducer(
  initialState,
  on(InventoryActions.loadInventoryItems, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(InventoryActions.loadInventoryItemsSuccess, (state, { assets }) => ({
    ...state,
    assets,
    loading: false,
    error: null,
  })),
  on(InventoryActions.loadInventoryItemsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(InventoryActions.getInventoryAssetById, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(InventoryActions.getInventoryAssetByIdSuccess, (state, { asset }) => {
    const existingAssetIndex = state.assets.findIndex((a) => a.id === asset.id);
    const updatedAssets = existingAssetIndex !== -1
      ? state.assets.map((existingAsset, index) => index === existingAssetIndex ? asset : existingAsset)
      : [...state.assets, asset];

    return {
      ...state,
      loading: false,
      assets: updatedAssets,
    };
  }),
  on(InventoryActions.getInventoryAssetByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(InventoryActions.createSellingOffer, (state) => ({
    ...state,
    selling: true,
    sellOfferError: null,
    error: null,
  })),
  on(InventoryActions.createSellingOfferSuccess, (state, { offer }) => ({
    ...state,
    assets: state.assets.map((asset) => {
      if (asset.id === offer.inventoryItemIds[0]) {
        return {
          ...asset,
          status: offer.status,
          offerId: offer.id,
          prices: offer.prices || [],
        };
      } else {
        return asset;
      }
    }),
    selling: false,
    sellOfferError: null,
    error: null,
  })),
  on(InventoryActions.createSellingOfferFailure, (state, { error }) => ({
    ...state,
    selling: false,
    sellOfferError: error,
    error,
  })),
  on(InventoryActions.deleteSellingOffer, (state) => ({
    ...state,
    deleting: true,
    deleteOfferError: null,
    error: null,
  })),
  on(InventoryActions.deleteSellingOfferSuccess, (state, { offer }) => ({
    ...state,
    assets: state.assets.map((asset) => {
      if (asset.id === offer.inventoryItemIds[0]) {
        return {
          ...asset,
          status: offer.status,
        };
      } else {
        return asset;
      }
    }),
    deleting: false,
    deleteOfferError: null,
    error: null,
  })),
  on(InventoryActions.deleteSellingOfferFailure, (state, { error }) => ({
    ...state,
    deleting: false,
    deleteOfferError: error,
    error,
  })),
);
